import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import toString from 'lodash/toString';
import {photographerPageFilters} from '../../constants/photographers/photographerPageFilters.js';
import callApi, { callSelfAPI } from '../../util/apiCaller';

import {userNotify} from '../../modules/components/Toasts/ToastAdd';
import {setPageNotFound, setPageRedirect} from './AppActions';
import {sortTheList} from '../../util/utility';
import {callSearchAPI, callSearchPhotographers} from '../../util/vmSearch';
import venueCallApi, {uploadFile} from '../../util/apiVenueCaller';
import callVendorApi from '../../util/vendorApiCaller.js';
import {FILTER_TYPE_MIN_MAX, IMAGE, VIDEO} from '../../constants/constants.js';
// import callManagerApi from '../../util/managerApiCaller';
// export const TOGGLE_NEW_EVENT_PLAN_MODAL = 'TOGGLE_NEW_EVENT_PLAN_MODAL';
//SearchPage Header
export const PHOTOGRAPHER_SET_SUBAREAS = 'PHOTOGRAPHER_SET_SUBAREAS'; // copy
export const PHOTOGRAPHER_SET_FILTERS = 'PHOTOGRAPHER_SET_FILTERS'; // copy
export const PHOTOGRAPHER_SET_PAGE_FILTERS = 'PHOTOGRAPHER_SET_PAGE_FILTERS'; // copy
export const PHOTOGRAPHER_SET_APPLIED_FILTERS = 'PHOTOGRAPHER_SET_APPLIED_FILTERS'; //copy
export const PHOTOGRAPHER_SET_PAGETAGS = 'PHOTOGRAPHER_SET_PAGETAGS';
export const PHOTOGRAPHER_FETCHING_VENUES = 'PHOTOGRAPHER_FETCHING_VENUES';
export const PHOTOGRAPHER_GET_VENUES = 'PHOTOGRAPHER_GET_VENUES';
export const PHOTOGRAPHER_FETCH_REVIEWS_FOR_PAGE = 'PHOTOGRAPHER_FETCH_REVIEWS_FOR_PAGE';
export const PHOTOGRAPHER_FETCH_REVIEW_SUCCESS = 'PHOTOGRAPHER_FETCH_REVIEW_SUCCESS';
export const PHOTOGRAPHER_SET_VENUE_FILTER = 'PHOTOGRAPHER_SET_VENUE_FILTER';
export const PHOTOGRAPHER_SET_VENUE_FILTER_ITEM = 'PHOTOGRAPHER_SET_VENUE_FILTER_ITEM';
export const PHOTOGRAPHER_SET_MIN_MAX_FILTER_ITEM = 'PHOTOGRAPHER_SET_MIN_MAX_FILTER_ITEM';
export const PHOTOGRAPHER_RESET_FILTERS = 'PHOTOGRAPHER_RESET_FILTERS'; //copy
export const PHOTOGRAPHER_SET_VENUES = 'PHOTOGRAPHER_SET_VENUES';
export const PHOTOGRAPHER_SET_CITY = 'PHOTOGRAPHER_SET_CITY';
export const PHOTOGRAPHER_SET_SORT_FILTERS = 'PHOTOGRAPHER_SET_SORT_FILTERS';
export const PHOTOGRAPHER_SHORTLISTING_VENUE_FROM_LIST = 'PHOTOGRAPHER_SHORTLISTING_VENUE_FROM_LIST';
export const PHOTOGRAPHER_EVENT_MADE_STATE = 'PHOTOGRAPHER_EVENT_MADE_STATE';
export const PHOTOGRAPHER_SET_SELECTED_VENUE = 'PHOTOGRAPHER_SET_SELECTED_VENUE';
export const PHOTOGRAPHER_UPDATING_VENUE_SEARCH_VALIDATORS = 'PHOTOGRAPHER_UPDATING_VENUE_SEARCH_VALIDATORS';
export const PHOTOGRAPHER_UPDATE_VENUE_SEARCH_VALIDATORS = 'PHOTOGRAPHER_UPDATE_VENUE_SEARCH_VALIDATORS';
export const PHOTOGRAPHER_FETCHING_SEARCHLINKS = 'PHOTOGRAPHER_FETCHING_SEARCHLINKS';
export const PHOTOGRAPHER_LOAD_SEARCHLINK = 'PHOTOGRAPHER_LOAD_SEARCHLINK';
export const PHOTOGRAPHER_SET_ACTIVE_LINK_FILTERS = 'PHOTOGRAPHER_SET_ACTIVE_LINK_FILTERS';
export const PHOTOGRAPHER_UPDATE_LODE_MORE_VENUES = 'PHOTOGRAPHER_UPDATE_LODE_MORE_VENUES';
export const PHOTOGRAPHER_FETCHING_VENUE_DATA_FOR_COMPARE_PAGE = 'PHOTOGRAPHER_FETCHING_VENUE_DATA_FOR_COMPARE_PAGE';
export const PHOTOGRAPHER_FETCH_VENUE_DATA_FOR_COMPARE_PAGE = 'PHOTOGRAPHER_FETCH_VENUE_DATA_FOR_COMPARE_PAGE';
export const PHOTOGRAPHER_FETCHING_COMPARE_VENUES = 'PHOTOGRAPHER_FETCHING_COMPARE_VENUES';
export const PHOTOGRAPHER_CLEAR_COMPARE_VENUE_DATA = 'PHOTOGRAPHER_CLEAR_COMPARE_VENUE_DATA';
export const PHOTOGRAPHER_IS_UPLOADING_MEDIA = 'PHOTOGRAPHER_IS_UPLOADING_MEDIA';
export const PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE = 'PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE';
export const PHOTOGRAPHER_CLICKED_VENUE_SEARCH_PAGE = 'PHOTOGRAPHER_CLICKED_VENUE_SEARCH_PAGE';
export const PHOTOGRAPHER_FETCH_VENUE_SEARCH_PAGE_ALL_ASSET = 'PHOTOGRAPHER_FETCH_VENUE_SEARCH_PAGE_ALL_ASSET';


export function setSortPhotographerFilters(sortFilters) { //needed
    return {
        type: PHOTOGRAPHER_SET_SORT_FILTERS, //needed
        sortFilters: sortFilters,
    };
}

export function updateLodeMoreVenues(data) { //needed
    return {
        type: PHOTOGRAPHER_UPDATE_LODE_MORE_VENUES, //needed
        newVenues: data.venues,
        pageNum: data.pageNum,
        totalCount: data.totalCount,
    };
}

export function setActiveLinkFilters(val) { //needed
    return {
        type: PHOTOGRAPHER_SET_ACTIVE_LINK_FILTERS, //needed
        activeLinkFilters: val,
    };
}

export function fetchingCurrentUserReviewPage(page) { //needed
    return {
        type: PHOTOGRAPHER_FETCH_REVIEWS_FOR_PAGE, //needed
        isLoadingUserReviewsPage: page === 1,
        isFetchingUserReviews: true,
        currentUserReviewPage: page,
    };
}

export function sendReviewsFetchResponse(data) { //needed
    return {
        type: PHOTOGRAPHER_FETCH_REVIEW_SUCCESS, //needed
        isFetchingUserReviews: false,
        isLoadingUserReviewsPage: false,
        userReviews: data.reviews,
        userReviewCount: data.totalCount,
    };
}

export function setPhotographerFilterItem(paramName, value) { //needed
    return {
        type: PHOTOGRAPHER_SET_VENUE_FILTER_ITEM, //needed
        paramName: paramName,
        value: value,
    };
}

export function setMinMaxPhotographerFilterItem(paramName, value) { //needed
    return {
        type: PHOTOGRAPHER_SET_MIN_MAX_FILTER_ITEM, //needed
        paramName: paramName,
        value: value,
    };
}

export function setPhotographerFilter(paramName, value, isSelected) { //needed
    return {
        type: PHOTOGRAPHER_SET_VENUE_FILTER, //needed
        paramName: paramName,
        value: value,
        isSelected: isSelected,
    };
}

export function setAppliedPhotographerFilters(filters, from) { //needed
    return (dispatch) => {
        dispatch({
            type: PHOTOGRAPHER_SET_APPLIED_FILTERS, //needed
            appliedFilters: filters,
        });
    };
}

export function resetFilters() { //needed
    return {
        type: PHOTOGRAPHER_RESET_FILTERS, //needed
    };
}

export function setVenues(venues) { //needed
    return {
        type: PHOTOGRAPHER_SET_VENUES, //needed
        venues: venues,
    };
}

export function setCity(city) { //needed
    return {
        type: PHOTOGRAPHER_SET_CITY, //needed
        city: city,
    };
}

export function loadSubareas(subareas) { //needed
    return {
        type: PHOTOGRAPHER_SET_SUBAREAS,
        isLocationFiltersLoaded: true,
        locationFilters: subareas,
    };
}

export function fetchPhotographerBaseFilters(urlslug, query) {  //filter Options API Call

    //for photographers search filters data -  /search/vendor/photographer-in-delhi/p/list
    let url = `search/photographer/${urlslug}/base-filters`;

    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        const baseFilter = await callApi(url, 'GET');
        if (baseFilter?.status === 'Success') {
            dispatch(loadFilters(baseFilter.data, photographerPageFilters));
        } else {
            dispatch(loadFilters({data: {filters: [], sortsets: []}}, pageFilters));
        }
    };
}


export function fetchSubAreasByCity(cityslug, query) {
    let url = `search/venues/${toString(cityslug)}/subareas`;
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return async (dispatch) => {
        const res = await callApi(url, 'GET');
        if (res.status === 'Success') {

            dispatch(loadSubareas(res.data.locations));
        } else {
            dispatch(loadSubareas([]));
        }
    };
}

export function loadFilters(data, searchFilterList) { //needed
    let venueSearchParams = [];
    let venueSearchFilters = [];
    const DYNAMIC_LIST = ['servicetypes', 'locations'];
    const filteredList = data?.filters?.filter((f) => DYNAMIC_LIST.includes(f.keyName));
    if (filteredList?.length > 0) {
        venueSearchFilters = [...searchFilterList, ...filteredList]
        venueSearchFilters.map((venueSearch) => {
            if (venueSearch.filterType === FILTER_TYPE_MIN_MAX) {
                venueSearchParams.push(
                    {paramName: venueSearch.minQueryParamName},
                    {paramName: venueSearch.maxQueryParamName}
                );
            } else {
                venueSearchParams.push({paramName: venueSearch.queryParamName});
            }
            if (venueSearch.keyName === 'servicetypes') venueSearch.mobileSortOrder = 1;
            if (venueSearch.keyName === 'locations') venueSearch.mobileSortOrder = 2;
            if (venueSearch.keyName === 'budget') venueSearch.mobileSortOrder = 3;
            if (venueSearch.keyName === 'reviewcount') venueSearch.mobileSortOrder = 4;
            if (venueSearch.keyName === 'rating') venueSearch.mobileSortOrder = 5;
            if (venueSearch.keyName === 'numberofdays') venueSearch.mobileSortOrder = 6;
            if (venueSearch.keyName === 'sort') venueSearch.mobileSortOrder = 7;
            if (venueSearch?.params?.length > 0) {
                if (venueSearch?.keyName === 'servicetypes') {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                }
                if (venueSearch?.keyName === 'locations') {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                } else {
                    venueSearch?.params.sort((a, b) => sortTheList(a, b, 'value', 'asc'));
                    // venueSearch?.params.sort((a, b) => sortTheList(a, b, 'label', 'asc'));
                }
                if (venueSearch?.keyName === 'locations') {
                    venueSearch.displayName = 'Location';
                }
            } else if (venueSearch?.maxParams?.length > 0) {
                venueSearch?.maxParams.sort((a, b) =>
                    sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                );
            } else if (venueSearch?.minParams?.length > 0) {
                venueSearch?.minParams.sort((a, b) =>
                    sortTheList(parseInt(a), parseInt(b), 'label', 'asc')
                );
            }
            return venueSearch;
        })
            .sort((a, b) => sortTheList(a, b, 'mobileSortOrder', 'asc'));

    }
    return {
        type: PHOTOGRAPHER_SET_FILTERS, //needed
        isBaseFiltersLoaded: true,
        photographerSearchFilters: venueSearchFilters,
        sortFilters: data?.sortsets,
        photographerSearchParams: venueSearchParams,
    };
}

export function setNewPhotographerFilters(venueSearchFilters) { //needed
    return {
        type: PHOTOGRAPHER_SET_PAGE_FILTERS, //needed
        photographerSearchFilters: venueSearchFilters,
    };
}

export function loadPageTags(pagetags) { //needed
    return {
        type: PHOTOGRAPHER_SET_PAGETAGS, //needed
        pagetags: pagetags,
    };
}

export function showVenueListLoader() { //needed
    return {
        type: PHOTOGRAPHER_FETCHING_VENUES, //needed
        isFetchingVenues: true,
    };
}

export function loadPhotographerList(data) { //needed
    return {
        type: PHOTOGRAPHER_GET_VENUES, //needed
        isFetchingVenues: false,
        list: data.photographers,
        totalCount: data.totalCount,
        pageNum: data.pageNum,
        searchlink: data.searchlink,
        searchValidators: data.searchValidators,
    };
}

export function fetchPhotographerList(url, query) {
    let final_url = `v1/search/photographer`; // v1/search/photographer/:url/list?min_price=10000&max_price=500000
    if (url) {
        final_url = `${final_url}/${url}/list`
    }
    if (query && query !== '') {
        final_url = `${final_url}${query}`;
    }
    return async (dispatch) => {
        dispatch(showVenueListLoader());
        const res = await callSearchPhotographers(url);
        if (res.status === 'Success') {
            if (!isEmpty(res.data.searchlink)) {
                dispatch(loadPhotographerList(res.data));
            } else {
                dispatch(setPageNotFound(true));
            }
        }
    };
}

export function showLoadingVenueSearchValidators(val) { //needed
    return {
        type: PHOTOGRAPHER_UPDATING_VENUE_SEARCH_VALIDATORS, //needed
        isUpdatingVenueSearchValidators: !!val,
    };
}

export function loadVenueSearchValidators(data) {//needed
    return {
        type: PHOTOGRAPHER_UPDATE_VENUE_SEARCH_VALIDATORS, //needed
        isUpdatingVenueSearchValidators: false,
        searchValidators: data.searchValidators,
        totalCount: data.totalCount,
    };
}

export function fetchPhotographerFiltersForList(cityslug, keyword, query) {
    let url = `search/venues`;
    if (keyword && keyword !== '') {
        url = `${url}/${toString(cityslug)}/${keyword}/filter-count`;
    } else {
        url = `${url}/${toString(cityslug)}/venues/filter-count`;
    }
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return (dispatch) => {
        dispatch(showLoadingVenueSearchValidators(true));
        return callApi(url, 'get').then((res) => {
            if (res.status === 'Success') {
                dispatch(loadVenueSearchValidators(res.data));
            } else {
                dispatch(showLoadingVenueSearchValidators(false));
            }
        });
    };
}

export function fetchPackagesByVenueId(venueId) {
    return (dispatch) => {
        return callApi(`search/venue/${venueId}/packages`, 'get').then((res) => {
            dispatch();
        });
    };
}

// Venue Page

export function showVenuePageLoading() {
    return {
        type: FETCHING_VENUE,
        isLoadingVenuePage: true,
    };
}

export function loadVenuePage(data) {
    return {
        type: FETCH_VENUE_PAGE,
        venue: data.venue,
        mainPageVenue: data.mainPageVenue,
        packages: data.packages,
        images: data.images,
        menus: data.menus,
        venueQas: data.venueQas,
        venueFaqs: data.venueFaqs,
        comments: data.comments,
        totalCommentsCount: data.total,
        reviewPageNum: 1,
        isLoadingVenuePage: false,
        similarVenues: data.similarVenues,
        popularVenues: data.popularVenues,
        //  _________
        venueExpert: data.venueExpert,
        venueExpertReview: data.venueExpertReview,
    };
}


// c=0|c=1
// export function updateImageViewSeen(venueImageId) {
//   return (dispatch) => {
//     return callManagerApi(`api/v3/venueimages/${venueImageId}/update/image-seen`, 'post', { venueimage: { imageSeen: 1 } })
//       .then(res => {
//         if (res.status === 'Success') {
//           dispatch(true)
//         }
//       });
//   }
// }

export function cacheVenueUrl(cityslug, vm_id) {
    return (dispatch) => {
        return callApi(`venues/${cityslug}/${vm_id}/v2-pages`, 'GET').then((res) => res);
    };
}

export function decacheVenueUrl(cityslug, vm_id) {
    return (dispatch) => {
        return callApi(`venues/decache`, 'POST', {
            url: `${cityslug}/${vm_id}`,
        }).then((res) => res);
    };
}

export function fetchVenuePage(cityslug, url) {
    return (dispatch) => {
        dispatch(showVenuePageLoading());
        return venueCallApi(`venues/${toString(cityslug)}/${url}/v2-pages`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (isEmpty(res.data.venue)) {
                    dispatch(setPageNotFound(true));
                } else if (res.data.venue && res.data.venue.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.venue.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data.venue && res.data.venue.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    res.data.mainPageVenue = res.data.venue;
                    res.data.venueQas = res.data.venueQas;
                    dispatch(loadVenuePage(res.data));
                }
            }
        });
    };
}

export function fetchPageTagsByUrl(url) {
    return (dispatch) => {
        return callApi(`search/venues/pagetags`, 'POST', {
            baseUrl: url,
        }).then((res) => {
            dispatch(loadPageTags(res.data.pagetags));
        });
    };
}

export function showVenueReviewsLoading() {
    return {
        type: FETCHING_REVIEW,
        isFetchingUserReviews: true,
        comments: [],
        totalCommentsCount: 0,
    };
}

export function loadBaseVenue(venue) {
    return {
        type: FETCH_VENUE,
        venue: venue,
    };
}


export function toggleNewEventPlanForm(val) {
    return {
        type: TOGGLE_NEW_EVENT_PLAN_MODAL,
        isNewEventFormVisible: !!val,
    };
}

export function eventMadeState(val) {//needed
    return {
        type: PHOTOGRAPHER_EVENT_MADE_STATE, //needed
        isEventMade: !!val,
    };
}

export function setSelectedPhotographer(venue) { //needed
    return {
        type: PHOTOGRAPHER_SET_SELECTED_VENUE, //needed
        selectedVenue: venue,
    };
}

export function fetchSeoLink(url) {
    return (dispatch) => {
        return callApi(`search/venues/seolink/page/${url}`, 'get').then((res) => {
            if (res.status === 'Success') {
                if (res.data && res.data.isRedirectLinkAvailable) {
                    let data = {};
                    data.isPageRedirect = true;
                    data.redirectStatus = 301;
                    data.redirectUrl = res.data.redirectToLink;
                    dispatch(setPageRedirect(data));
                } else if (res.data && res.data.isDeleted) {
                    dispatch(setPageNotFound(true));
                } else {
                    dispatch(setPageNotFound(true));
                }
            }
        });
    };
}

export function fetchKeywordRedirect(cityslug, keyword) {
    return (dispatch) => {
        return callApi(
            `search/venues/${toString(cityslug)}/keyword/${keyword}/redirect`,
            'get'
        ).then((res) => {
            if (res.status === 'Success') {
                let data = {};
                data.isPageRedirect = true;
                data.redirectStatus = 301;
                if (res.data.redirectUrl) {
                    data.redirectUrl = res.data.redirectUrl;
                } else {
                    data.redirectUrl = `/${lowerCase(cityslug)}/venues`;
                }
                dispatch(setPageRedirect(data));
            }
        });
    };
}

export function loadFormFilters(data) {
    return {
        type: SET_VENUE_FORM_FILTERS,
        venueFormFilters: data,
    };
}

export function fetchVenueFormFilters(cityslug) {
    return (dispatch) => {
        return callApi(`search/venues/${toString(cityslug)}/venue-form-filters`, 'get').then(
            (res) => {
                if (res.status === 'Success') {
                    dispatch(loadFormFilters(res.data));
                }
            }
        );
    };
}

export function showShortlistingVenueSearchPageLoader(venueid, value) { //needed
    return {
        type: PHOTOGRAPHER_SHORTLISTING_VENUE_FROM_LIST, //needed
        venueid: venueid,
        value: value,
    };
}

export function showShortlistingVenuePageLoader(value) {
    return {
        type: SHORTLISTING_VENUE_FOR_EVENT,
        isShortlistingVenue: value,
    };
}

export function loadingSearchLink(val) { //needed
    return {
        type: PHOTOGRAPHER_FETCHING_SEARCHLINKS, //needed
        isFetchingSearchLink: !!val,
    };
}

export function loadSearchLink(data) { //needed
    return {
        type: PHOTOGRAPHER_LOAD_SEARCHLINK, //needed
        isFetchingSearchLink: false,
        searchlink: {
            tags: data.tags,
            keyword: data.keyword,
            city: data.city,
            query: data.query,
        },
        list: data.venues,
        totalCount: data.totalCount,
        pageSize: data.pageSize,
        pageNum: data.pageNum,
        occasionFilters: data.occasions,
        venuetypeFilters: data.venuetypes,
        amenityFilters: data.facilities,
        minBudgetFilters: data.minBudgets,
        maxBudgetFilters: data.maxBudgets,
        minGuestFilters: data.minCapacity,
        maxGuestFilters: data.maxCapacity,
        locationFilters: data.locations,
        regionFilters: data.regions,
        packagetypeFilters: data.packagetypes,
        sortFilters: data.sortsets,
    };
}

export function fetchSearchLink(cityslug, url) {
    return (dispatch) => {
        dispatch(loadingSearchLink(true));
        return callApi(`search/venues/${toString(cityslug)}/searchlink/page/${url}`, 'get').then(
            (res) => {
                if (res.status === 'Success') {
                    if (isEmpty(res.data)) {
                        dispatch(setPageNotFound(true));
                    } else if (res.data && res.data.isRedirectLinkAvailable) {
                        let data = {};
                        data.isPageRedirect = true;
                        data.redirectStatus = 301;
                        data.redirectUrl = res.data.redirectToLink;
                        dispatch(setPageRedirect(data));
                    } else if (res.data && res.data.isDeleted) {
                        dispatch(setPageNotFound(true));
                    } else {
                        dispatch(loadSearchLink(res.data));
                    }
                }
            }
        );
    };
}


export function showLoaderCompareVenues(val) { //needed
    return {
        type: PHOTOGRAPHER_FETCHING_COMPARE_VENUES, //needed
        isFetchingCompareVenues: val,
    };
}

export function showVenueDataLoading(val) { //needed
    return {
        type: PHOTOGRAPHER_FETCHING_VENUE_DATA_FOR_COMPARE_PAGE, //needed
        isLoadingVenueData: val,
    };
}

export function loadVenueData(data) { //needed
    return {
        type: PHOTOGRAPHER_FETCH_VENUE_DATA_FOR_COMPARE_PAGE, //needed
        compareVenue: data,
    };
}

export function fetchVenueData(url, colName) {
    return async (dispatch) => {
        dispatch(showVenueDataLoading(true));
        const res = await callApi(`venues/${url}`, 'get');
        if (res.status === 'Success') {
            if (isEmpty(res.data.venue)) {
                dispatch(setPageNotFound(true));
                dispatch(showVenueDataLoading(false));
            } else {
                let compareVenue = {};
                compareVenue[colName] = res.data.venue;
                dispatch(loadVenueData(compareVenue));
                dispatch(showVenueDataLoading(false));
            }
        }
    };
}

export function clearVenueData() { //needed
    return {
        type: PHOTOGRAPHER_CLEAR_COMPARE_VENUE_DATA, //needed
    };
}


export function isUploadingMedia(val) { //needed
    return {
        type: PHOTOGRAPHER_IS_UPLOADING_MEDIA, //needed
        payload: val,
    };
}

export function mediaUploaded(data) {
}

export function uploadMedia(file, fileName, filePath, cityslug, url) {
    return async (dispatch) => {
        dispatch(isUploadingMedia(true));
        let data = new FormData();
        data.append('file', file);

        const res = await uploadFile(`v1/assets/upload?fileName=${filePath}`, 'post', data);
        if (res.status === 'Success') {
            dispatch(isUploadingMedia(false));
            dispatch(fetchVenuePage(cityslug, url));
        } else {
            console.log('Error in uploading media');
            userNotify('Error in uploading media', 'error');
        }
    };
}

export function openGalleryForVenueImagesGallery(val, photographer, isFetchingVenueAssets) {
    return {
        type: PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        photographer: photographer,
        isFetchingVenueAssets: isFetchingVenueAssets
    };
}

export function closeGalleryForPhotographerImagesGallery(val) {
    return {
        type: PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
        isVenueGalleryOpen: val,
        isFetchingVenueAssets: val,
    };
}

export function clickedVenueOnSearchPage(val) { //needed
    return {
        type: PHOTOGRAPHER_CLICKED_VENUE_SEARCH_PAGE, //needed
        payload: val,
    };
}

export function loadPhotographerSearchPageAssets(photographer_id, images, assets) { //needed
    return {
        type: PHOTOGRAPHER_FETCH_VENUE_SEARCH_PAGE_ALL_ASSET, //needed
        photographer_id: photographer_id,
        images,
        assets,
    };
}

export function fetchPhotographerSearchPageAllAsset(photographer) {
    return async (dispatch, getState) => {
        let clickedVenueAssets = getState()?.PhotographerReducers?.clickedVenueAssets;
        if (
            !clickedVenueAssets?.[photographer?._id]?.images ||
            !(clickedVenueAssets?.[photographer?._id]?.images?.length > 0)
        ) {
            dispatch(openGalleryForVenueImagesGallery(true, photographer, true));
            const res = await callVendorApi(`photographer-asset/list`, 'post', {
                filters: {
                    photographer_id: photographer?._id,
                    is_deleted: false
                }
            });
            if (res.status === 'Success') {
                let images = res.data.photographer_assetList.filter(asset => asset.asset_type === IMAGE)
                let videos = res.data.photographer_assetList.filter(asset => asset.asset_type === VIDEO)
                dispatch(
                    loadPhotographerSearchPageAssets(
                        photographer._id,
                        images,
                        videos
                    )
                );
            } else {
                userNotify('Error in fetching media', 'error');
            }
        } else {
            dispatch(openGalleryForVenueImagesGallery(true, photographer, false));
        }
    };
}
